import React, { useState } from 'react';
import { PlusIcon, PencilIcon, TrashIcon, SearchIcon } from 'lucide-react';
export const TraitLibrary: React.FC = () => {
  const [traits, setTraits] = useState([{
    id: 1,
    name: 'Communication',
    category: 'Soft Skills',
    description: 'Ability to clearly convey information and ideas to others',
    minRange: 0,
    maxRange: 100,
    linkedAssessments: ['MBTI', 'Career Interest Inventory']
  }, {
    id: 2,
    name: 'Creativity',
    category: 'Cognitive',
    description: 'Ability to generate novel ideas and solutions',
    minRange: 0,
    maxRange: 100,
    linkedAssessments: ['DMIT', 'Astrological Chart']
  }, {
    id: 3,
    name: 'Analytical Thinking',
    category: 'Cognitive',
    description: 'Ability to break down complex problems and analyze data',
    minRange: 0,
    maxRange: 100,
    linkedAssessments: ['MBTI', 'DMIT']
  }, {
    id: 4,
    name: 'Leadership',
    category: 'Soft Skills',
    description: 'Ability to guide and motivate others towards a common goal',
    minRange: 0,
    maxRange: 100,
    linkedAssessments: ['MBTI', 'Career Interest Inventory']
  }, {
    id: 5,
    name: 'Technical Aptitude',
    category: 'Hard Skills',
    description: 'Proficiency with tools, systems, and technical concepts',
    minRange: 0,
    maxRange: 100,
    linkedAssessments: ['DMIT', 'Career Interest Inventory']
  }]);
  const [editingTrait, setEditingTrait] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const filteredTraits = traits.filter(trait => {
    return trait.name.toLowerCase().includes(searchTerm.toLowerCase()) && (filterCategory === '' || trait.category === filterCategory);
  });
  const categories = Array.from(new Set(traits.map(trait => trait.category)));
  const handleAddTrait = () => {
    setEditingTrait({
      id: traits.length + 1,
      name: '',
      category: '',
      description: '',
      minRange: 0,
      maxRange: 100,
      linkedAssessments: []
    });
    setIsModalOpen(true);
  };
  const handleEditTrait = (trait: any) => {
    setEditingTrait({
      ...trait
    });
    setIsModalOpen(true);
  };
  const handleDeleteTrait = (id: number) => {
    setTraits(traits.filter(trait => trait.id !== id));
  };
  const handleSaveTrait = () => {
    if (editingTrait) {
      if (traits.some(t => t.id === editingTrait.id)) {
        setTraits(traits.map(t => t.id === editingTrait.id ? editingTrait : t));
      } else {
        setTraits([...traits, editingTrait]);
      }
      setIsModalOpen(false);
      setEditingTrait(null);
    }
  };
  return <div data-id="element-502">
      <div className="mb-6" data-id="element-503">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-504">
          Trait Library Manager
        </h1>
        <p className="text-gray-600" data-id="element-505">
          Manage personality and career traits used in assessments and matching
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-506">
        <div className="p-6 border-b border-gray-200" data-id="element-507">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0" data-id="element-508">
            <div className="flex items-center space-x-4" data-id="element-509">
              <div className="relative" data-id="element-510">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-511">
                  <SearchIcon size={16} className="text-gray-400" data-id="element-512" />
                </div>
                <input type="text" placeholder="Search traits..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#7D56F4] focus:border-[#7D56F4] w-full sm:w-64" data-id="element-513" />
              </div>
              <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)} className="border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-514">
                <option value="" data-id="element-515">All Categories</option>
                {categories.map(category => <option key={category} value={category} data-id="element-516">
                    {category}
                  </option>)}
              </select>
            </div>
            <button onClick={handleAddTrait} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#7D56F4] hover:bg-[#6A46E5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4]" data-id="element-517">
              <PlusIcon size={16} className="mr-2" data-id="element-518" />
              Add Trait
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-519">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-520">
            <thead className="bg-gray-50" data-id="element-521">
              <tr data-id="element-522">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-523">
                  Trait Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-524">
                  Category
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-525">
                  Description
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-526">
                  Range
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-527">
                  Linked Assessments
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-528">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-529">
              {filteredTraits.map(trait => <tr key={trait.id} data-id="element-530">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-531">
                    <div className="text-sm font-medium text-gray-900" data-id="element-532">
                      {trait.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-533">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-534">
                      {trait.category}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-535">
                    <div className="text-sm text-gray-500 max-w-xs truncate" data-id="element-536">
                      {trait.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-537">
                    <div className="text-sm text-gray-500" data-id="element-538">
                      {trait.minRange} - {trait.maxRange}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-539">
                    <div className="flex flex-wrap gap-1" data-id="element-540">
                      {trait.linkedAssessments.map((assessment, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800" data-id="element-541">
                          {assessment}
                        </span>)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-542">
                    <button onClick={() => handleEditTrait(trait)} className="text-[#7D56F4] hover:text-[#6A46E5] mr-3" data-id="element-543">
                      <PencilIcon size={16} data-id="element-544" />
                    </button>
                    <button onClick={() => handleDeleteTrait(trait.id)} className="text-red-500 hover:text-red-700" data-id="element-545">
                      <TrashIcon size={16} data-id="element-546" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200" data-id="element-547">
          <div className="flex justify-between items-center" data-id="element-548">
            <div className="text-sm text-gray-700" data-id="element-549">
              Showing{' '}
              <span className="font-medium" data-id="element-550">{filteredTraits.length}</span> of{' '}
              <span className="font-medium" data-id="element-551">{traits.length}</span> traits
            </div>
            <div data-id="element-552">
              <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-553">
                Export as CSV
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Edit/Add Trait Modal */}
      {isModalOpen && <div className="fixed inset-0 overflow-y-auto z-50" data-id="element-554">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-555">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-556">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-557"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-558">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-559">
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" data-id="element-560">
                  {editingTrait?.id ? 'Edit Trait' : 'Add New Trait'}
                </h3>
                <div className="space-y-4" data-id="element-561">
                  <div data-id="element-562">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-563">
                      Trait Name
                    </label>
                    <input type="text" id="name" value={editingTrait?.name || ''} onChange={e => setEditingTrait({
                  ...editingTrait,
                  name: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-564" />
                  </div>
                  <div data-id="element-565">
                    <label htmlFor="category" className="block text-sm font-medium text-gray-700" data-id="element-566">
                      Category
                    </label>
                    <input type="text" id="category" value={editingTrait?.category || ''} onChange={e => setEditingTrait({
                  ...editingTrait,
                  category: e.target.value
                })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" list="categories" data-id="element-567" />
                    <datalist id="categories" data-id="element-568">
                      {categories.map(category => <option key={category} value={category} data-id="element-569" />)}
                    </datalist>
                  </div>
                  <div data-id="element-570">
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700" data-id="element-571">
                      Description
                    </label>
                    <textarea id="description" value={editingTrait?.description || ''} onChange={e => setEditingTrait({
                  ...editingTrait,
                  description: e.target.value
                })} rows={3} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-572" />
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-573">
                    <div data-id="element-574">
                      <label htmlFor="minRange" className="block text-sm font-medium text-gray-700" data-id="element-575">
                        Min Range
                      </label>
                      <input type="number" id="minRange" value={editingTrait?.minRange || 0} onChange={e => setEditingTrait({
                    ...editingTrait,
                    minRange: parseInt(e.target.value)
                  })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-576" />
                    </div>
                    <div data-id="element-577">
                      <label htmlFor="maxRange" className="block text-sm font-medium text-gray-700" data-id="element-578">
                        Max Range
                      </label>
                      <input type="number" id="maxRange" value={editingTrait?.maxRange || 100} onChange={e => setEditingTrait({
                    ...editingTrait,
                    maxRange: parseInt(e.target.value)
                  })} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-579" />
                    </div>
                  </div>
                  <div data-id="element-580">
                    <label className="block text-sm font-medium text-gray-700" data-id="element-581">
                      Linked Assessments
                    </label>
                    <div className="mt-2 space-y-2" data-id="element-582">
                      {['MBTI', 'DMIT', 'Astrological Chart', 'Career Interest Inventory'].map(assessment => <div key={assessment} className="flex items-center" data-id="element-583">
                          <input type="checkbox" id={`assessment-${assessment}`} checked={editingTrait?.linkedAssessments?.includes(assessment) || false} onChange={e => {
                      const updatedAssessments = e.target.checked ? [...(editingTrait?.linkedAssessments || []), assessment] : (editingTrait?.linkedAssessments || []).filter(a => a !== assessment);
                      setEditingTrait({
                        ...editingTrait,
                        linkedAssessments: updatedAssessments
                      });
                    }} className="h-4 w-4 text-[#7D56F4] focus:ring-[#7D56F4] border-gray-300 rounded" data-id="element-584" />
                          <label htmlFor={`assessment-${assessment}`} className="ml-2 text-sm text-gray-700" data-id="element-585">
                            {assessment}
                          </label>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-586">
                <button type="button" onClick={handleSaveTrait} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#7D56F4] text-base font-medium text-white hover:bg-[#6A46E5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4] sm:ml-3 sm:w-auto sm:text-sm" data-id="element-587">
                  Save
                </button>
                <button type="button" onClick={() => setIsModalOpen(false)} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7D56F4] sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-588">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};